var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzureIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 840,
    height: 659,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C277.2 0 554.4 0 840 0 C840 217.47 840 434.94 840 659 C562.8 659 285.6 659 0 659 C0 441.53 0 224.06 0 0 Z ",
    fill: "#F6F8F9",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.90416388 2.72055384 4.98547132 5.34832701 6.9609375 8.796875 C7.78150635 10.21734131 7.78150635 10.21734131 8.61865234 11.66650391 C9.19824707 12.68405762 9.7778418 13.70161133 10.375 14.75 C11.62480129 16.91938532 12.87480726 19.08865274 14.125 21.2578125 C14.764375 22.37188477 15.40375 23.48595703 16.0625 24.63378906 C19.13963457 29.98000019 22.25961817 35.30102139 25.375 40.625 C29.56844904 47.80692334 33.72780514 55.00556828 37.83984375 62.234375 C40.71191524 67.26015071 43.64192786 72.25231918 46.5625 77.25 C53.45527219 89.04736954 60.2889155 100.87820494 67.10888672 112.71777344 C70.23680148 118.14659942 73.36858448 123.57319281 76.5 129 C77.75001879 131.16665583 79.00001878 133.3333225 80.25 135.5 C80.86875 136.5725 81.4875 137.645 82.125 138.75 C117.75 200.5 117.75 200.5 119.62524414 203.75048828 C120.87435518 205.91557071 122.12354129 208.08060982 123.37280273 210.24560547 C126.51202309 215.68615706 129.64990563 221.12747216 132.78515625 226.5703125 C138.80747375 237.02206279 144.84680257 247.46293115 150.9375 257.875 C156.67753421 267.69138458 162.33323337 277.55465494 167.96630859 287.43261719 C174.31923895 298.57152504 180.72546631 309.6793258 187.14111328 320.78222656 C190.26324605 326.18670645 193.38141204 331.59347412 196.5 337 C197.74998122 339.1666775 198.99998121 341.33334417 200.25 343.5 C219 376 219 376 237.75 408.5 C238.36866943 409.57233887 238.98733887 410.64467773 239.62475586 411.74951172 C240.8756448 413.91776264 242.12645852 416.08605697 243.37719727 418.25439453 C246.48798335 423.64717915 249.60004238 429.03922093 252.71484375 434.4296875 C259.53502637 446.23629484 266.3232326 458.06027 273.07736206 469.90472412 C277.67394517 477.96263727 282.3137136 485.99389826 287 494 C291.95460184 502.47385919 296.88876078 510.95921574 301.77929688 519.47021484 C302.50596362 520.73346215 303.23413878 521.99584304 303.96386719 523.25732422 C304.97744905 525.01030705 305.98496479 526.76679314 306.9921875 528.5234375 C307.57339355 529.53325684 308.15459961 530.54307617 308.75341797 531.58349609 C310 534 310 534 310 536 C121.9 536 -66.2 536 -260 536 C-260 535.67 -260 535.34 -260 535 C-205.57761788 525.25354206 -205.57761788 525.25354206 -178.87127686 520.60125732 C-167.95434065 518.69827025 -157.0423897 516.76831549 -146.13272858 514.82409096 C-129.04445173 511.77935368 -111.95322816 508.7515461 -94.859375 505.73828125 C-93.84711412 505.55982855 -92.83485325 505.38137585 -91.7919178 505.19751549 C-86.58670629 504.2799222 -81.38146333 503.36250743 -76.1762085 502.44515991 C-42.73785927 496.55182923 -9.3018777 490.64558305 24.125 484.6875 C24.85664871 484.55709446 25.58829742 484.42668892 26.34211731 484.2923317 C30.52876643 483.54606621 34.71535003 482.79943418 38.90188599 482.0525341 C40.8447907 481.70600027 42.78775125 481.35977954 44.73071289 481.01356506 C50.50920551 479.98323154 56.28705225 478.94962334 62.06273842 477.90367794 C64.04802223 477.54428462 66.03351547 477.18604886 68.01901245 476.82783508 C70.48142036 476.38337729 72.94345825 475.93686295 75.40505981 475.48796082 C76.49326019 475.29188736 77.58146057 475.0958139 78.70263672 474.89379883 C79.65709686 474.72052567 80.61155701 474.5472525 81.59494019 474.36872864 C84 474 84 474 87 474 C80.43497946 465.9112463 73.74631335 457.93738661 67 450 C61.80780978 443.89111965 56.61876419 437.78489359 51.5625 431.5625 C47.60491812 426.69870975 43.53457554 421.94118769 39.44165039 417.19165039 C35.66665609 412.8019965 31.99271539 408.33885229 28.34375 403.84375 C25.10036237 399.90843967 21.76853203 396.05180698 18.43920898 392.18920898 C15.42754991 388.68764698 12.4694105 385.15213443 9.5625 381.5625 C5.94572974 377.10400866 2.21148032 372.76245777 -1.5625 368.4375 C-5.80341977 363.57601695 -9.92236268 358.6555647 -13.9140625 353.5859375 C-17.02487374 349.72946364 -20.27187573 345.99325706 -23.50805664 342.24194336 C-26.55709687 338.7012928 -29.55540741 335.12863587 -32.5 331.5 C-35.93208013 327.2720752 -39.44551171 323.1247211 -43 319 C-47.31934272 313.98685227 -51.55097277 308.91462485 -55.72265625 303.77734375 C-58.28204054 300.65603633 -60.88593791 297.5754997 -63.5 294.5 C-67.6144923 289.65820922 -71.65730569 284.76435589 -75.66796875 279.8359375 C-78.80315963 276.02329331 -81.99413759 272.25926436 -85.1953125 268.50195312 C-86.46839834 267.00542006 -87.73435387 265.50283021 -89 264 C-89.78761719 263.19304687 -90.57523438 262.38609375 -91.38671875 261.5546875 C-93.63511444 257.99427398 -92.80299204 256.07237374 -92 252 C-91.33317163 249.84559312 -90.60096026 247.71058301 -89.8125 245.59765625 C-89.36567871 244.39012695 -88.91885742 243.18259766 -88.45849609 241.93847656 C-87.97242967 240.64644715 -87.48626187 239.35445587 -87 238.0625 C-86.49888453 236.71475126 -85.99840428 235.36676618 -85.49853516 234.01855469 C-83.21584212 227.872758 -80.90319876 221.73830467 -78.5859375 215.60546875 C-77.84870432 213.65374176 -77.11171977 211.70192084 -76.375 209.75 C-76.00705322 208.77522705 -75.63910645 207.8004541 -75.26000977 206.79614258 C-72.70455045 199.98477615 -70.29141448 193.13332537 -67.9375 186.25 C-62.34401462 169.91602496 -56.38564067 153.71556096 -50.46327209 137.498703 C-47.54004181 129.49055579 -44.63357654 121.47639838 -41.73046875 113.4609375 C-40.38564576 109.75102382 -39.04059599 106.04119243 -37.69546509 102.33139038 C-36.82502071 99.92935496 -35.95535313 97.52703789 -35.08651733 95.12442017 C-30.94798601 83.68222079 -26.78099466 72.27576948 -22.19433594 61.00512695 C-20.59150231 56.97215901 -19.24095611 52.88723282 -17.9375 48.75 C-14.61585406 38.49946829 -10.88486032 28.40821039 -7.125 18.3125 C-6.83019745 17.51976685 -6.5353949 16.72703369 -6.23165894 15.91027832 C-5.38807225 13.64391199 -4.54232603 11.37836886 -3.6953125 9.11328125 C-3.43832077 8.42464493 -3.18132904 7.73600861 -2.91654968 7.02650452 C-1.11827577 2.23655154 -1.11827577 2.23655154 0 0 Z ",
    fill: "#0088D3",
    transform: "translate(482,83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.02368651 4.42944912 -1.01813915 6.73692612 -2.1640625 9.0859375 C-2.50740128 9.80587891 -2.85074005 10.52582031 -3.20448303 11.26757812 C-4.33763717 13.64014883 -5.48146157 16.00741936 -6.625 18.375 C-7.4134517 20.02250187 -8.20096068 21.67045523 -8.98754883 23.31884766 C-10.1821779 25.822252 -11.37727761 28.32541469 -12.57521057 30.82723999 C-16.0015832 37.98450469 -19.35880518 45.17172534 -22.6875 52.375 C-23.74069926 54.64982578 -24.79408462 56.92456541 -25.84765625 59.19921875 C-26.62520264 60.87830322 -26.62520264 60.87830322 -27.41845703 62.59130859 C-29.85853338 67.85039256 -32.31366536 73.10242206 -34.7684021 78.35467529 C-39.04329865 87.50148271 -43.30654436 96.65351409 -47.546875 105.81640625 C-47.93973694 106.66533447 -48.33259888 107.5142627 -48.73736572 108.38891602 C-49.54314339 110.13022318 -50.34890907 111.87153589 -51.15466309 113.612854 C-57.84558554 128.07192605 -64.57362712 142.51223003 -71.3699646 156.92205811 C-77.44030089 169.7930419 -83.44772295 182.69221868 -89.42773438 195.60546875 C-92.09465692 201.3633711 -94.7658285 207.11929994 -97.4375 212.875 C-97.97576416 214.03475342 -98.51402832 215.19450684 -99.06860352 216.3894043 C-103.19369886 225.27332665 -107.33610281 234.14910789 -111.48269653 243.02301025 C-115.18498063 250.94758042 -118.8734009 258.87843693 -122.546875 266.81640625 C-122.93978226 267.66542511 -123.33268951 268.51444397 -123.73750305 269.38919067 C-124.54332808 271.13058866 -125.34913952 272.87199293 -126.15493774 274.61340332 C-132.86741335 289.11929496 -139.61885927 303.60543431 -146.43936157 318.06085205 C-151.17495749 328.0987238 -155.85890993 338.15861007 -160.49609375 348.24243164 C-164.43773398 356.80500758 -168.43119882 365.342557 -172.4375 373.875 C-178.80622849 387.44030477 -185.13176396 401.02503587 -191.43359375 414.62158203 C-193.47565542 419.02589147 -195.52090143 423.4287184 -197.56616211 427.83154297 C-203.1561166 439.86592268 -208.73894853 451.90360374 -214.3190918 463.9425354 C-215.14484436 465.7239713 -215.97068999 467.50536405 -216.79663086 469.28671265 C-220.82497402 477.97501057 -224.85077243 486.66436395 -228.84765625 495.3671875 C-229.13417557 495.99049957 -229.42069489 496.61381165 -229.71589661 497.25601196 C-231.01716412 500.08692718 -232.31638904 502.9187362 -233.61157227 505.75244141 C-234.05170654 506.71069824 -234.49184082 507.66895508 -234.9453125 508.65625 C-235.32187988 509.47931641 -235.69844727 510.30238281 -236.08642578 511.15039062 C-237 513 -237 513 -238 514 C-240.20225454 514.0970006 -242.40768664 514.12186709 -244.61207581 514.12025452 C-245.31121768 514.12110894 -246.01035956 514.12196337 -246.73068756 514.12284368 C-249.09074751 514.12450051 -251.45073753 514.11897384 -253.81079102 514.11352539 C-255.49564614 514.11324354 -257.18050139 514.11340122 -258.86535645 514.1139679 C-263.45400453 514.11425594 -268.0426267 514.10835811 -272.63126874 514.10139394 C-277.42124632 514.09516153 -282.21122443 514.09455669 -287.00120544 514.09336853 C-296.07829032 514.09025488 -305.15536321 514.08204104 -314.2324428 514.07201904 C-324.56358581 514.06085895 -334.89472939 514.05534772 -345.22587693 514.05032361 C-366.48392465 514.03985845 -387.74196157 514.02225836 -409 514 C-407.59629093 510.4078232 -406.03056306 507.14262786 -404.0859375 503.80859375 C-403.49804443 502.79587402 -402.91015137 501.7831543 -402.30444336 500.73974609 C-401.66772705 499.65000488 -401.03101074 498.56026367 -400.375 497.4375 C-399.0076454 495.08548771 -397.64263628 492.73211596 -396.27734375 490.37890625 C-395.9251326 489.77260376 -395.57292145 489.16630127 -395.21003723 488.54162598 C-391.75497215 482.58995687 -388.34499682 476.61294161 -384.93902588 470.63308716 C-379.11560792 460.41060909 -373.23039405 450.22627014 -367.28662109 440.07324219 C-362.48588404 431.86084825 -357.75859742 423.60738625 -353.046875 415.34375 C-348.22207465 406.88179246 -343.37431361 398.43357068 -338.5 390 C-333.3075944 381.0145896 -328.14348749 372.01346203 -323 363 C-312.53916186 344.67216069 -301.9932248 326.39504631 -291.33935547 308.17871094 C-286.49838683 299.88649945 -281.73339232 291.55194662 -276.97976685 283.20953369 C-272.36515923 275.11292071 -267.70906575 267.04216251 -263 259 C-257.96809701 250.40481841 -252.99681205 241.7764819 -248.0625 233.125 C-247.39277967 231.95139388 -246.72302063 230.77780985 -246.05322266 229.60424805 C-245.72163147 229.02324844 -245.39004028 228.44224884 -245.04840088 227.84364319 C-240.66441122 220.16247974 -236.2786023 212.48244124 -231.875 204.8125 C-231.27179932 203.75627441 -230.66859863 202.70004883 -230.04711914 201.61181641 C-220.28844715 184.64318541 -220.28844715 184.64318541 -213.8125 179 C-212.37970703 177.74509766 -212.37970703 177.74509766 -210.91796875 176.46484375 C-207.26895934 173.38248105 -203.58993546 170.34239812 -199.875 167.33984375 C-196.75975403 164.80447373 -193.68751009 162.22356266 -190.625 159.625 C-190.08262695 159.16504639 -189.54025391 158.70509277 -188.98144531 158.23120117 C-187.32034728 156.82152451 -185.66003294 155.4109307 -184 154 C-177.89111965 148.80780978 -171.78489359 143.61876419 -165.5625 138.5625 C-160.69870975 134.60491812 -155.94118769 130.53457554 -151.19165039 126.44165039 C-146.8019965 122.66665609 -142.33885229 118.99271539 -137.84375 115.34375 C-134.52313406 112.60697862 -131.25956291 109.80893615 -128 107 C-122.98685227 102.68065728 -117.91462485 98.44902723 -112.77734375 94.27734375 C-109.65603733 91.71796028 -106.57546576 89.11410084 -103.5 86.5 C-99.55349519 83.14552873 -95.58357928 79.82778171 -91.5625 76.5625 C-86.14429421 72.15086945 -80.8472915 67.60676358 -75.55078125 63.05078125 C-67.39024023 56.0321361 -59.1605176 49.10739804 -50.8125 42.3125 C-47.1190609 39.2756723 -43.47701514 36.18039045 -39.83374023 33.08374023 C-36.44045891 30.2045468 -33.01732214 27.36795763 -29.5625 24.5625 C-25.29255001 21.08927537 -21.10502281 17.53200945 -16.9375 13.9375 C-11.39326919 9.15595157 -5.76424251 4.51576602 0 0 Z ",
    fill: "#0188D3",
    transform: "translate(456,42)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C26.6 20 33.2 20 40 20 C40 26.6 40 33.2 40 40 C46.6 40 53.2 40 60 40 C60 46.6 60 53.2 60 60 C54.06 60 48.12 60 42 60 C42 60.66 42 61.32 42 62 C42.66 62 43.32 62 44 62 C43.67 62.66 43.34 63.32 43 64 C39.00080947 73.20929134 35.47680349 82.58515068 32 92 C30.52408449 87.57225348 31.89091985 84.50156059 33 80 C28.71 80 24.42 80 20 80 C20 73.4 20 66.8 20 60 C13.4 60 6.8 60 0 60 C1.52595621 55.42213136 3.20570042 51.18758599 5.2578125 46.8515625 C5.56572723 46.19417084 5.87364197 45.53677917 6.19088745 44.85946655 C7.16582421 42.77983871 8.14532997 40.70240162 9.125 38.625 C9.7906688 37.20717404 10.45603643 35.78920664 11.12109375 34.37109375 C12.74391788 30.91241723 14.37084056 27.4556966 16 24 C12.59170063 25.61817175 10.20469242 27.47765964 7.4375 30.0625 C3.07546239 34.06156514 -1.41677877 37.82883366 -6.015625 41.55078125 C-9.38761487 44.31810802 -12.69662321 47.15150415 -16 50 C-21.01299606 54.31951465 -26.08538117 58.55097766 -31.22265625 62.72265625 C-34.34396267 65.28203972 -37.42453424 67.88589916 -40.5 70.5 C-44.44650481 73.85447127 -48.41642072 77.17221829 -52.4375 80.4375 C-57.30129025 84.39508188 -62.05881231 88.46542446 -66.80834961 92.55834961 C-71.18692978 96.32382078 -75.63626421 99.9912615 -80.125 103.625 C-82.33897829 105.45393859 -84.51991941 107.304776 -86.6875 109.1875 C-87.31978516 109.73599609 -87.95207031 110.28449219 -88.60351562 110.84960938 C-89.84528833 111.93024576 -91.08371229 113.01474521 -92.31835938 114.10351562 C-94.86461237 116.31878477 -96.76425212 117.92141737 -100 119 C-100 112.73 -100 106.46 -100 100 C-93.4 100 -86.8 100 -80 100 C-80 93.4 -80 86.8 -80 80 C-73.4 80 -66.8 80 -60 80 C-60 73.4 -60 66.8 -60 60 C-53.4 60 -46.8 60 -40 60 C-40 53.4 -40 46.8 -40 40 C-33.4 40 -26.8 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EAEDEE",
    transform: "translate(440,20)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.41120527 7.17213413 14.06859675 15.00622426 20.55078125 23.015625 C23.31810802 26.38761487 26.15150415 29.69662321 29 33 C33.31951465 38.01299606 37.55097766 43.08538117 41.72265625 48.22265625 C44.74485223 51.90838753 47.83147207 55.53744822 50.91870117 59.16870117 C53.77859495 62.53870316 56.59262982 65.94035256 59.375 69.375 C62.9972518 73.82816261 66.72867568 78.1734951 70.5 82.5 C75.00991535 87.67382468 79.42497413 92.90541083 83.7421875 98.2421875 C86.36804456 101.44954924 89.05772041 104.59844654 91.75 107.75 C95.39580616 112.02566723 98.85661683 116.3391215 102 121 C101 122 101 122 99.05053711 122.11352539 C98.2178833 122.10828857 97.38522949 122.10305176 96.52734375 122.09765625 C95.71773193 122.09515869 94.90812012 122.09266113 94.07397461 122.09008789 C93.03893799 122.08098389 92.00390137 122.07187988 90.9375 122.0625 C87.658125 122.041875 84.37875 122.02125 81 122 C81 115.4 81 108.8 81 102 C74.4 102 67.8 102 61 102 C61 95.4 61 88.8 61 82 C54.4 82 47.8 82 41 82 C41 75.4 41 68.8 41 62 C34.4 62 27.8 62 21 62 C21 55.4 21 48.8 21 42 C14.4 42 7.8 42 1 42 C1 35.4 1 28.8 1 22 C-5.6 22 -12.2 22 -19 22 C-19 15.4 -19 8.8 -19 2 C-12.73 2 -6.46 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#EAECEE",
    transform: "translate(419,378)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C5.95 2 10.9 2 16 2 C16 8.6 16 15.2 16 22 C22.6 22 29.2 22 36 22 C36 28.6 36 35.2 36 42 C29.4 42 22.8 42 16 42 C16 48.6 16 55.2 16 62 C9.4 62 2.8 62 -4 62 C-4 55.4 -4 48.8 -4 42 C-8.95 42.33 -13.9 42.66 -19 43 C-16.75028345 36.25085034 -16.75028345 36.25085034 -15.32006836 33.24536133 C-15.00311508 32.57479202 -14.6861618 31.90422272 -14.35960388 31.21333313 C-14.02308304 30.51000351 -13.68656219 29.80667389 -13.33984375 29.08203125 C-12.9899086 28.34297043 -12.63997345 27.60390961 -12.2794342 26.842453 C-11.16867739 24.49759081 -10.05340635 22.15491538 -8.9375 19.8125 C-7.81862841 17.4590944 -6.7007582 15.10522619 -5.58485413 12.75041199 C-4.89225364 11.28933027 -4.19785239 9.8291005 -3.50144958 8.36982727 C-2.1882051 5.60309788 -0.96958523 2.90875568 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(384,198)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0 13.86 0 21 0 C21 6.6 21 13.2 21 20 C25.29 20 29.58 20 34 20 C32.58823529 34.82352941 32.58823529 34.82352941 30 40 C27.03 40 24.06 40 21 40 C21 46.6 21 53.2 21 60 C14.4 60 7.8 60 1 60 C1 53.4 1 46.8 1 40 C-4.94 40 -10.88 40 -17 40 C-16.1173355 35.58667749 -14.82491359 32.1177163 -12.91015625 28.125 C-12.60556992 27.47805176 -12.30098358 26.83110352 -11.98716736 26.16455078 C-11.01745233 24.1072082 -10.04032262 22.0534998 -9.0625 20 C-8.0896752 17.94585693 -7.11842911 15.89098202 -6.14854431 13.83544922 C-5.54620728 12.5600778 -4.94194846 11.28561165 -4.33546448 10.01220703 C-2.7671339 6.70403424 -1.36233818 3.40584544 0 0 Z ",
    fill: "#F1F3F4",
    transform: "translate(439,80)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C12.54 0 25.08 0 38 0 C38 6.6 38 13.2 38 20 C31.4 20 24.8 20 18 20 C18 26.6 18 33.2 18 40 C11.4 40 4.8 40 -2 40 C-2 33.4 -2 26.8 -2 20 C-186.8 20 -371.6 20 -562 20 C-562 19.01 -562 18.02 -562 17 C-560.02 16.67 -558.04 16.34 -556 16 C-555.67 16.66 -555.34 17.32 -555 18 C-275.325 18.495 -275.325 18.495 10 19 C6.7 13.06 3.4 7.12 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#DDFAFE",
    transform: "translate(782,600)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.76390737 2.40339772 3.04065919 3.16263678 4 7 C-184.1 7 -372.2 7 -566 7 C-566 6.67 -566 6.34 -566 6 C-562.08755486 5.25889114 -558.17322319 4.52883284 -554.25683594 3.80883789 C-552.92554597 3.56250066 -551.5948043 3.3131804 -550.26464844 3.06079102 C-548.34978612 2.6979976 -546.4327192 2.34690222 -544.515625 1.99609375 C-543.36352539 1.78138428 -542.21142578 1.5666748 -541.02441406 1.34545898 C-538 1 -538 1 -534 2 C-536.64 2.66 -539.28 3.32 -542 4 C-362.81 4 -183.62 4 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#1F83BC",
    transform: "translate(788,612)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 6.6 15 13.2 15 20 C21.6 20 28.2 20 35 20 C35 26.6 35 33.2 35 40 C41.6 40 48.2 40 55 40 C55 46.6 55 53.2 55 60 C48.73 60 42.46 60 36 60 C35.505 60.99 35.505 60.99 35 62 C34.62302979 61.32122803 34.24605957 60.64245605 33.85766602 59.94311523 C25.31709795 44.48086728 25.31709795 44.48086728 16.375 29.25 C12.63285943 23.09562893 9.01728462 16.87521804 5.4375 10.625 C4.63094971 9.22169434 4.63094971 9.22169434 3.80810547 7.79003906 C3.3132666 6.9234668 2.81842773 6.05689453 2.30859375 5.1640625 C1.86314209 4.38498535 1.41769043 3.6059082 0.95874023 2.80322266 C0 1 0 1 0 0 Z ",
    fill: "#E9EDEE",
    transform: "translate(505,120)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C11.56542064 3.58644839 10.16640336 6.67342435 8.3046875 10.0078125 C7.76110596 10.98210205 7.21752441 11.9563916 6.6574707 12.96020508 C6.06925537 14.0045874 5.48104004 15.04896973 4.875 16.125 C4.26551514 17.20998779 3.65603027 18.29497559 3.02807617 19.4128418 C-1.78333101 27.93488019 -6.70452096 36.38977475 -11.6875 44.8125 C-12.03274719 45.39735168 -12.37799438 45.98220337 -12.73370361 46.58477783 C-13.71929536 48.25225436 -14.70917456 49.91719444 -15.69921875 51.58203125 C-16.26471436 52.53311768 -16.83020996 53.4842041 -17.4128418 54.46411133 C-18.83971626 56.74390598 -20.34860571 58.87927191 -22 61 C-22.495 60.505 -22.495 60.505 -23 60 C-25.86469325 59.92669669 -28.69893674 59.90782169 -31.5625 59.9375 C-34.346875 59.958125 -37.13125 59.97875 -40 60 C-40 53.4 -40 46.8 -40 40 C-33.4 40 -26.8 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E8ECEE",
    transform: "translate(100,440)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0.495 6.93 0.495 14 1 C14 7.6 14 14.2 14 21 C20.6 21 27.2 21 34 21 C34 27.6 34 34.2 34 41 C40.6 41 47.2 41 54 41 C54 47.6 54 54.2 54 61 C47.73 61.33 41.46 61.66 35 62 C32.958125 58.2875 32.958125 58.2875 30.875 54.5 C25.00139359 43.88580238 18.86582499 33.42719955 12.73388672 22.9609375 C10.02349324 18.33243114 7.32082839 13.69950293 4.625 9.0625 C3.91935913 7.85509155 3.91935913 7.85509155 3.19946289 6.62329102 C0 1.11462414 0 1.11462414 0 0 Z ",
    fill: "#ECEDED",
    transform: "translate(666,399)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C6.61 3 12.22 3 18 3 C18 9.6 18 16.2 18 23 C11.4 23 4.8 23 -2 23 C-2 29.6 -2 36.2 -2 43 C-7.61 43 -13.22 43 -19 43 C-17.44141356 38.32424069 -15.7027883 34.0129809 -13.59375 29.58984375 C-13.26838257 28.89991837 -12.94301514 28.20999298 -12.60778809 27.49916077 C-11.57503896 25.31042058 -10.53780837 23.12384524 -9.5 20.9375 C-8.46286738 18.74727455 -7.42672842 16.55658994 -6.39221191 14.36512756 C-5.7505754 13.00645609 -5.10734762 11.64853459 -4.46228027 10.29148865 C-2.85837824 6.90068553 -1.34741194 3.5010142 0 0 Z ",
    fill: "#E9ECEE",
    transform: "translate(282,417)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C19 6.6 19 13.2 19 20 C25.6 20 32.2 20 39 20 C39 26.6 39 33.2 39 40 C34.05 40 29.1 40 24 40 C23.67 40.66 23.34 41.32 23 42 C22.65855957 41.3922876 22.31711914 40.7845752 21.96533203 40.15844727 C20.35360352 37.29216225 18.73967327 34.4271272 17.125 31.5625 C16.54016846 30.52456299 15.95533691 29.48662598 15.3527832 28.41723633 C11.2961721 21.23854162 7.16607543 14.1095311 2.89697266 7.05493164 C0 2.21350706 0 2.21350706 0 0 Z ",
    fill: "#E9ECEE",
    transform: "translate(621,320)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C17.55214711 3.61963223 16.14796699 6.68190323 14.2421875 10.02734375 C13.70231201 10.97859131 13.16243652 11.92983887 12.60620117 12.90991211 C12.03490479 13.90901611 11.4636084 14.90812012 10.875 15.9375 C10.29403564 16.9591626 9.71307129 17.9808252 9.11450195 19.03344727 C7.41286068 22.02413199 5.70699711 25.01236979 4 28 C3.12097898 29.54160123 2.24205916 31.08326017 1.36328125 32.625 C-0.42054363 35.75226079 -2.2085324 38.87710935 -4 42 C-4.33 41.34 -4.66 40.68 -5 40 C-9.95 40 -14.9 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E9EDEE",
    transform: "translate(140,360)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 -0.15234375 5.64453125 C-0.74144531 6.68996094 -1.33054688 7.73539062 -1.9375 8.8125 C-2.25525391 9.38145996 -2.57300781 9.95041992 -2.90039062 10.53662109 C-3.57843072 11.74632128 -4.26135953 12.95329213 -4.94873047 14.15771484 C-5.97733339 15.96027816 -6.99196794 17.77007109 -8.00390625 19.58203125 C-9.32486718 21.93881623 -10.66837234 24.28027691 -12.03295898 26.61206055 C-13.31544746 28.82095872 -14.56189093 31.05130235 -15.76586914 33.30395508 C-19.82853077 40.51167818 -19.82853077 40.51167818 -23.04638672 41.85302734 C-25.31003988 42.08730536 -27.17860205 41.98068264 -29.4375 41.6875 C-31.933125 41.460625 -34.42875 41.23375 -37 41 C-37 34.4 -37 27.8 -37 21 C-30.4 21 -23.8 21 -17 21 C-17 14.4 -17 7.8 -17 1 C-8.585 0.505 -8.585 0.505 0 0 Z ",
    fill: "#FBFDFE",
    transform: "translate(77,499)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94 0 11.88 0 18 0 C18 6.6 18 13.2 18 20 C24.6 20 31.2 20 38 20 C38 26.6 38 33.2 38 40 C24.375 40.125 24.375 40.125 21 39 C19.59301758 36.99731445 19.59301758 36.99731445 18.14453125 34.36328125 C17.339552 32.91731567 17.339552 32.91731567 16.51831055 31.44213867 C15.67393433 29.89296753 15.67393433 29.89296753 14.8125 28.3125 C13.64882245 26.21072432 12.48476049 24.10916143 11.3203125 22.0078125 C10.75473633 20.98075195 10.18916016 19.95369141 9.60644531 18.89550781 C6.91053548 14.03631471 4.09893533 9.24539667 1.29296875 4.44921875 C0 2 0 2 0 0 Z ",
    fill: "#FAFDFD",
    transform: "translate(702,460)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94 0 11.88 0 18 0 C18 6.6 18 13.2 18 20 C24.6 20 31.2 20 38 20 C38 26.6 38 33.2 38 40 C34.473125 40.2784375 34.473125 40.2784375 30.875 40.5625 C30.14651855 40.64443604 29.41803711 40.72637207 28.66748047 40.81079102 C26.8671875 40.87890625 26.8671875 40.87890625 23 40 C20.41639968 37.3331334 18.76731871 34.24574879 17 31 C15.96490612 29.23433843 14.92974894 27.46871398 13.89453125 25.703125 C12.8638318 23.88731735 11.83650637 22.06959054 10.8125 20.25 C9.77778773 18.42162367 8.74264542 16.59349063 7.70703125 14.765625 C7.2581958 13.96930664 6.80936035 13.17298828 6.34692383 12.35253906 C5.38507134 10.67256615 4.37369487 9.02055661 3.33081055 7.38964844 C2 5 2 5 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FAFDFE",
    transform: "translate(482,80)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.61 0 11.22 0 17 0 C17 6.6 17 13.2 17 20 C23.6 20 30.2 20 37 20 C37 26.6 37 33.2 37 40 C32.38 40.33 27.76 40.66 23 41 C9.23400287 17.50185411 9.23400287 17.50185411 3.625 7.5625 C3.25060791 6.90185547 2.87621582 6.24121094 2.49047852 5.56054688 C0 1.12290155 0 1.12290155 0 0 Z ",
    fill: "#E8ECEE",
    transform: "translate(563,220)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.61 0 11.22 0 17 0 C10.20234883 14.14646325 2.13454701 27.58899007 -6 41 C-12.93 40.505 -12.93 40.505 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E8EDEF",
    transform: "translate(200,260)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C5.95 2 10.9 2 16 2 C16 8.6 16 15.2 16 22 C9.4 22 2.8 22 -4 22 C-4 28.6 -4 35.2 -4 42 C-8.95 42.33 -13.9 42.66 -19 43 C-16.75028345 36.25085034 -16.75028345 36.25085034 -15.32006836 33.24536133 C-15.00311508 32.57479202 -14.6861618 31.90422272 -14.35960388 31.21333313 C-14.02308304 30.51000351 -13.68656219 29.80667389 -13.33984375 29.08203125 C-12.9899086 28.34297043 -12.63997345 27.60390961 -12.2794342 26.842453 C-11.16867739 24.49759081 -10.05340635 22.15491538 -8.9375 19.8125 C-7.81862841 17.4590944 -6.7007582 15.10522619 -5.58485413 12.75041199 C-4.89225364 11.28933027 -4.19785239 9.8291005 -3.50144958 8.36982727 C-2.1882051 5.60309788 -0.96958523 2.90875568 0 0 Z ",
    fill: "#EBECED",
    transform: "translate(384,198)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0.33 10.56 0.66 16 1 C16 7.6 16 14.2 16 21 C9.4 21 2.8 21 -4 21 C-4 27.6 -4 34.2 -4 41 C-8.29 41 -12.58 41 -17 41 C-17 41.66 -17 42.32 -17 43 C-17.66 43 -18.32 43 -19 43 C-16.70920908 35.45386522 -13.53787831 28.56928352 -10.0625 21.5 C-6.5879908 14.38045355 -3.1660343 7.2628064 0 0 Z ",
    fill: "#EAEDEE",
    transform: "translate(244,499)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C10.46640779 5.47233478 9.4693646 10.08682593 7.53125 15.2734375 C7.29088013 15.92325592 7.05051025 16.57307434 6.80285645 17.24258423 C6.04325463 19.28981652 5.27174408 21.33231858 4.5 23.375 C3.98230764 24.76664264 3.46537397 26.15856776 2.94921875 27.55078125 C-0.76314487 37.52628973 -0.76314487 37.52628973 -2 40 C-7.94 40 -13.88 40 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(420,220)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C14.13971045 4.30144774 13.40586182 6.44164031 11.3046875 10.09765625 C10.75756104 11.05921631 10.21043457 12.02077637 9.64672852 13.01147461 C8.45336377 15.06652204 7.2585094 17.12070508 6.06225586 19.17407227 C2.32406694 25.54988671 2.32406694 25.54988671 -0.92578125 32.1796875 C-3.48343912 37.69153935 -3.48343912 37.69153935 -6 40 C-11.04576781 41.01026988 -14.79384038 40.59498967 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#F9FDFE",
    transform: "translate(120,400)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C15 6.6 15 13.2 15 20 C21.6 20 28.2 20 35 20 C35 26.6 35 33.2 35 40 C23.70829844 40.62042316 23.70829844 40.62042316 20.51855469 37.82641602 C18.06954378 35.07804463 16.35365152 32.50955922 14.58984375 29.2890625 C13.69362305 27.66871094 13.69362305 27.66871094 12.77929688 26.015625 C12.17150391 24.89671875 11.56371094 23.7778125 10.9375 22.625 C9.71755805 20.40879354 8.49750884 18.19264612 7.27734375 15.9765625 C6.71128418 14.93790039 6.14522461 13.89923828 5.56201172 12.82910156 C4.27073084 10.49034526 2.93590519 8.19158003 1.56640625 5.8984375 C0 3 0 3 0 0 Z ",
    fill: "#FAFDFE",
    transform: "translate(645,360)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8 0.66 8 1.32 8 2 C8.8962207 2.38913574 8.8962207 2.38913574 9.81054688 2.78613281 C12.17262586 4.09570648 13.35495099 5.32263626 15.03125 7.421875 C15.58917236 8.11120117 16.14709473 8.80052734 16.72192383 9.51074219 C17.60207153 10.6191748 17.60207153 10.6191748 18.5 11.75 C19.74192707 13.29292566 20.98544526 14.83457182 22.23046875 16.375 C22.85614746 17.14972656 23.48182617 17.92445313 24.12646484 18.72265625 C25.89603661 20.87362907 27.70623426 22.97569803 29.55078125 25.0625 C30.10121094 25.68672852 30.65164063 26.31095703 31.21875 26.95410156 C32.25700568 28.12404776 33.30227314 29.2878205 34.35546875 30.44433594 C37.36907082 33.85961287 38.06327155 35.31635776 39 40 C32.73 40 26.46 40 20 40 C20 33.4 20 26.8 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#F7FCFD",
    transform: "translate(380,340)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0.33 10.56 0.66 16 1 C16 7.6 16 14.2 16 21 C22.6 21 29.2 21 36 21 C36 27.6 36 34.2 36 41 C32.37 41 28.74 41 25 41 C24.67 41.66 24.34 42.32 24 43 C10.5370646 20.0832478 10.5370646 20.0832478 4.125 8.5625 C3.49198975 7.42868896 3.49198975 7.42868896 2.84619141 6.27197266 C0 1.12660924 0 1.12660924 0 0 Z ",
    fill: "#E8EDEF",
    transform: "translate(724,499)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C4.63 4 8.26 4 12 4 C12 10.6 12 17.2 12 24 C5.4 24 -1.2 24 -8 24 C-8 30.6 -8 37.2 -8 44 C-11.63 44 -15.26 44 -19 44 C-19.495 46.475 -19.495 46.475 -20 49 C-20.33 49.66 -20.66 50.32 -21 51 C-21.66 51 -22.32 51 -23 51 C-21.62507498 46.61967497 -19.94179102 42.53200228 -17.98828125 38.37890625 C-17.69696823 37.75708969 -17.40565521 37.13527313 -17.10551453 36.49461365 C-16.17761385 34.51576711 -15.24518539 32.53909515 -14.3125 30.5625 C-13.70607141 29.2716294 -13.0999494 27.98061472 -12.49414062 26.68945312 C-11.28353874 24.11014335 -10.07128353 21.53162033 -8.85791016 18.95361328 C-5.88971909 12.64301965 -2.94577356 6.3210803 0 0 Z ",
    fill: "#E9ECEE",
    transform: "translate(348,276)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C6.64034 6.84013569 4.63746418 13.165329 2.1875 19.6875 C1.4723385 21.62097625 0.75749501 23.55457015 0.04296875 25.48828125 C-0.30459473 26.42365723 -0.6521582 27.3590332 -1.01025391 28.32275391 C-2.36852392 31.99685084 -3.68927617 35.68372358 -5 39.375 C-5.391875 40.47585937 -5.78375 41.57671875 -6.1875 42.7109375 C-6.5896875 43.84402344 -6.5896875 43.84402344 -7 45 C-7.33 43.68 -7.66 42.36 -8 41 C-11.96 40.67 -15.92 40.34 -20 40 C-20 33.4 -20 26.8 -20 20 C-13.4 20 -6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#ECEDED",
    transform: "translate(460,120)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(780,620)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,620)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,620)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,620)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,620)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,620)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,620)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,620)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,620)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,620)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,620)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,620)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,620)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,600)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,600)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,600)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,600)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,600)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,600)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,600)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,600)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,600)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,600)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,600)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,600)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,580)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,580)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(300,580)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(260,580)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,580)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,580)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,580)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,580)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,580)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,580)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,580)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,580)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,580)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,580)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,580)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,580)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,560)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,560)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,560)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,560)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,560)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,560)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,560)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,560)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,560)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,560)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,560)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,560)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,560)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,560)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,560)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,560)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,560)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,560)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,560)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,560)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,560)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,560)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,560)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,540)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,540)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,540)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,540)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,540)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,540)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,540)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,540)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,540)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,540)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,540)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,540)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,540)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,540)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,540)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(260,540)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,540)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(20,540)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,540)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,520)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,520)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,520)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,520)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,520)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,520)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,520)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(420,520)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,520)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,520)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,520)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,520)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,520)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,520)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,520)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,520)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,500)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,500)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,500)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,500)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFE",
    transform: "translate(740,500)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,500)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,500)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,500)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,500)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,500)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,500)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,500)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,500)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,500)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,500)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,500)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,500)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,480)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,480)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,480)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,480)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,480)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFD",
    transform: "translate(480,480)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,480)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(440,480)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(420,480)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,480)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,480)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,480)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,480)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,480)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,480)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,480)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,480)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,480)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,460)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,460)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,460)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,460)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,460)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,460)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(460,460)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,460)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(420,460)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,460)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,460)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,460)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,460)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,460)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,460)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,460)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,460)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,460)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,460)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,440)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,440)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,440)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,440)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,440)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,440)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(440,440)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(420,440)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,440)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,440)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,440)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,440)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,440)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(80,440)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,440)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,440)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,440)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,440)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,420)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,420)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,420)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,420)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,420)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,420)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFD",
    transform: "translate(700,420)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(420,420)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,420)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,420)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,420)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,420)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,420)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,420)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,420)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,420)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,420)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,420)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,420)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,400)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,400)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,400)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,400)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,400)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,400)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,400)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(680,400)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(400,400)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,400)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,400)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,400)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,400)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,400)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,400)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,400)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,400)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,400)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,400)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,400)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,380)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,380)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,380)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,380)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,380)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,380)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,380)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,380)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,380)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,380)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,380)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,380)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,380)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,380)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,380)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,380)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,380)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,380)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,360)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,360)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,360)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,360)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,360)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,360)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,360)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,360)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,360)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,360)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,360)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,360)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,360)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,360)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,360)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,360)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,360)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,360)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,360)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,360)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,340)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,340)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,340)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,340)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,340)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,340)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,340)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,340)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,340)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,340)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,340)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,340)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,340)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,340)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,340)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,340)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,340)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,340)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,320)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,320)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,320)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,320)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,320)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,320)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,320)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,320)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,320)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,320)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,320)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,320)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,320)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,320)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,320)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,320)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,320)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,320)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,320)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,300)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,300)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,300)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,300)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,300)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,300)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,300)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,300)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,300)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,300)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(620,300)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(340,300)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,300)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,300)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,300)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,300)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,300)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,300)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,300)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,300)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,300)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,280)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,280)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,280)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,280)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,280)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,280)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,280)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,280)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,280)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,280)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,280)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,280)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,280)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,280)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,280)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,280)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,280)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,280)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,280)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,280)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,280)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,280)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,260)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,260)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,260)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,260)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,260)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,260)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,260)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,260)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,260)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,260)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,260)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,260)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,260)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,260)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(180,260)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,260)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,260)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,260)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,260)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,260)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,260)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,260)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,260)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,260)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,240)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,240)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,240)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,240)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,240)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,240)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,240)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,240)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,240)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,240)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,240)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,240)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,240)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,240)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,240)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,240)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,240)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,240)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,240)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,240)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,240)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,240)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,240)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,220)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,220)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,220)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,220)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,220)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,220)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,220)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,220)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,220)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,220)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,220)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,220)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,220)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFE",
    transform: "translate(380,220)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,220)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,220)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,220)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,220)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,220)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,220)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,220)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,220)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,220)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,220)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,220)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,200)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,200)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,200)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,200)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,200)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,200)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,200)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,200)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,200)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,200)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,200)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,200)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,200)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(400,200)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,200)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,200)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,200)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,200)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,200)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,200)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,200)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,200)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,200)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,200)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,200)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,200)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,180)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,180)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,180)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,180)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,180)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,180)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,180)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,180)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,180)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,180)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,180)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,180)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,180)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,180)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,180)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,180)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,180)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,180)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,180)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,180)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,180)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,180)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,180)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,180)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,180)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,180)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,180)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,180)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,160)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,160)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,160)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,160)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,160)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,160)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,160)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,160)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,160)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,160)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,160)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,160)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,160)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(560,160)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,160)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,160)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,160)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,160)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,160)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,160)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,160)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,160)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,160)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,160)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,160)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,160)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,160)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,160)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,140)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,140)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,140)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,140)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,140)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,140)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,140)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,140)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,140)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,140)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,140)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,140)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,140)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,140)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(540,140)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(420,140)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,140)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(260,140)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,140)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,140)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,140)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,140)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,140)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,140)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,140)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,140)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,140)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,140)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,140)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,140)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,140)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,120)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,120)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,120)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,120)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,120)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,120)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,120)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,120)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,120)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,120)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,120)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,120)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,120)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(560,120)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(540,120)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(520,120)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFD",
    transform: "translate(440,120)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFD",
    transform: "translate(320,120)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,120)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,120)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,120)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,120)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,120)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,120)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,120)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,120)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,120)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,120)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,120)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,120)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,120)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,120)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,120)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,120)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,100)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,100)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,100)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,100)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,100)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,100)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,100)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,100)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,100)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,100)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,100)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,100)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,100)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,100)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(540,100)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(520,100)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFD",
    transform: "translate(340,100)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,100)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,100)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,100)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(260,100)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,100)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,100)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,100)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,100)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,100)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,100)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,100)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,100)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,100)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,100)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,100)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,100)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,100)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,80)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,80)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,80)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,80)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,80)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,80)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,80)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,80)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,80)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,80)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,80)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,80)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,80)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(560,80)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(540,80)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(520,80)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,80)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(440,80)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFDFD",
    transform: "translate(360,80)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,80)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,80)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,80)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,80)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,80)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,80)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,80)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,80)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,80)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,80)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,80)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,80)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,80)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,80)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,80)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,80)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,80)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,80)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,60)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,60)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,60)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,60)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,60)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,60)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,60)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,60)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,60)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,60)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,60)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,60)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,60)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,60)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(540,60)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(520,60)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,60)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFEFD",
    transform: "translate(460,60)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,60)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,60)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,60)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,60)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,60)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,60)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(260,60)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,60)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,60)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,60)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,60)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,60)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,60)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,60)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,60)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,60)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,60)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,60)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,60)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,60)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,40)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(800,40)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,40)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(760,40)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,40)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(720,40)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,40)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(680,40)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,40)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(640,40)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,40)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(600,40)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,40)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(560,40)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(540,40)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(520,40)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,40)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(480,40)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(400,40)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,40)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(360,40)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,40)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(320,40)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,40)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(280,40)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,40)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(240,40)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,40)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(200,40)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,40)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(160,40)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,40)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(120,40)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,40)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(80,40)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,40)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(40,40)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,40)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,40)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(820,20)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(800,20)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(780,20)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,20)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(740,20)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,20)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(700,20)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,20)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(660,20)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,20)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(620,20)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,20)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(580,20)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,20)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(540,20)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(520,20)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(500,20)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,20)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(460,20)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(420,20)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,20)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(380,20)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,20)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(340,20)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,20)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(300,20)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,20)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(260,20)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,20)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(220,20)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(200,20)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(180,20)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(160,20)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(140,20)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(120,20)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(100,20)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(80,20)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(60,20)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(40,20)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(20,20)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(0,20)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(800,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(760,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(720,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(680,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(640,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(600,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(560,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(540,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(520,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(480,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(440,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(420,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(400,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(360,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(320,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(280,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(240,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(200,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(160,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(120,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(80,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(40,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.114375 -0.020625 6.22875 -0.04125 9.4375 -0.0625 C10.91174438 -0.07615601 10.91174438 -0.07615601 12.41577148 -0.09008789 C13.18477783 -0.09258545 13.95378418 -0.09508301 14.74609375 -0.09765625 C15.93223267 -0.10551147 15.93223267 -0.10551147 17.14233398 -0.11352539 C19 0 19 0 20 1 C20.08651611 2.41570123 20.10704904 3.835595 20.09765625 5.25390625 C20.09515869 6.0229126 20.09266113 6.79191895 20.09008789 7.58422852 C20.08098389 8.56705811 20.07187988 9.5498877 20.0625 10.5625 C20.041875 13.676875 20.02125 16.79125 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFD",
    transform: "translate(520,520)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20.020625 2.5575 20.04125 5.115 20.0625 7.75 C20.071604 8.54889648 20.08070801 9.34779297 20.09008789 10.17089844 C20.10386858 13.70053223 19.86244046 16.55023818 19 20 C12.73 20 6.46 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(140,340)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(820,640)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(800,640)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(780,640)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(760,640)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(740,640)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(720,640)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(700,640)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(680,640)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(660,640)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(640,640)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(620,640)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(600,640)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(580,640)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(560,640)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(540,640)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(520,640)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(500,640)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(480,640)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(460,640)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(440,640)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(420,640)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(400,640)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(380,640)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(360,640)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(340,640)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(320,640)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(300,640)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(280,640)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(260,640)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(240,640)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(220,640)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(200,640)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(180,640)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(160,640)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(140,640)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(120,640)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(100,640)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(80,640)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(60,640)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(40,640)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(20,640)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(0,640)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(760,621)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(740,621)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(720,621)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(680,621)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(660,621)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(640,621)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(600,621)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(580,621)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(560,621)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(520,621)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(500,621)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(480,621)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(440,621)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(420,621)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(400,621)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(360,621)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(340,621)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(320,621)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(280,621)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FEFEFD",
    transform: "translate(260,621)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.27 20 12.54 20 19 C13.4 19 6.8 19 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#EDEDED",
    transform: "translate(240,621)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 12.87 1 25.74 1 39 C-4.61 39 -10.22 39 -16 39 C-14.875 31.125 -14.875 31.125 -13.50952148 28.26782227 C-13.20928574 27.62768692 -12.90904999 26.98755157 -12.59971619 26.32801819 C-12.27677078 25.66418625 -11.95382538 25.00035431 -11.62109375 24.31640625 C-11.28956802 23.61603745 -10.9580423 22.91566864 -10.61647034 22.19407654 C-9.56559547 19.97924184 -8.50182092 17.77089965 -7.4375 15.5625 C-6.71853632 14.05314597 -6.00042859 12.54338391 -5.28320312 11.03320312 C-3.53199719 7.3506768 -1.76920261 3.67391185 0 0 Z ",
    fill: "#F7FCFD",
    transform: "translate(299,381)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C0.34 4 -0.32 4 -1 4 C-1.33 5.32 -1.66 6.64 -2 8 C80.665 7.505 80.665 7.505 165 7 C165.66 5.35 166.32 3.7 167 2 C167.66 2 168.32 2 169 2 C167.125 8.875 167.125 8.875 166 10 C163.79774546 10.0970006 161.59231336 10.12186709 159.38792419 10.12025452 C158.68878232 10.12110894 157.98964044 10.12196337 157.26931244 10.12284368 C154.90925249 10.12450051 152.54926247 10.11897384 150.18920898 10.11352539 C148.50435386 10.11324354 146.81949861 10.11340122 145.13464355 10.1139679 C140.54599547 10.11425594 135.9573733 10.10835811 131.36873126 10.10139394 C126.57875368 10.09516153 121.78877557 10.09455669 116.99879456 10.09336853 C107.92170968 10.09025488 98.84463679 10.08204104 89.7675572 10.07201904 C79.43641419 10.06085895 69.10527061 10.05534772 58.77412307 10.05032361 C37.51607535 10.03985845 16.25803843 10.02225836 -5 10 C-3.61702141 6.42229452 -2.04383021 3.25154807 0 0 Z ",
    fill: "#3D9DD3",
    transform: "translate(52,546)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C13 6.6 13 13.2 13 20 C6.4 20 -0.2 20 -7 20 C-6.28571429 7.14285714 -6.28571429 7.14285714 -3 2 C-2.01 2 -1.02 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#FBFDFD",
    transform: "translate(227,540)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.62 20 9.24 20 14 C24.455 13.505 24.455 13.505 29 13 C29 12.34 29 11.68 29 11 C32.63 11 36.26 11 40 11 C40 11.33 40 11.66 40 12 C35.77465509 12.85351332 31.54426166 13.67894504 27.3125 14.5 C26.13365234 14.73847656 24.95480469 14.97695313 23.74023438 15.22265625 C15.68466069 16.76756079 8.2021459 17.22863124 0 17 C0 11.39 0 5.78 0 0 Z ",
    fill: "#E8EDEF",
    transform: "translate(220,600)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 5.28 20 10.56 20 16 C13.05527861 18.31490713 7.29002058 18.58735733 0 19 C0 12.73 0 6.46 0 0 Z ",
    fill: "#FBFDFD",
    transform: "translate(440,560)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C17.875 6.75 17.875 6.75 16.58984375 10.0859375 C16.32236328 10.78847656 16.05488281 11.49101562 15.77929688 12.21484375 C15.50150391 12.92769531 15.22371094 13.64054688 14.9375 14.375 C14.65583984 15.11105469 14.37417969 15.84710938 14.08398438 16.60546875 C13.39433382 18.4055736 12.69786068 20.2030621 12 22 C11.67 21.34 11.34 20.68 11 20 C7.37 20 3.74 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E9EDEE",
    transform: "translate(420,200)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 6.6 11 13.2 11 20 C4.73 20 -1.54 20 -8 20 C-8 13.92485609 -7.46277641 12.13078418 -5 7 C-4.01 7 -3.02 7 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#FBFDFE",
    transform: "translate(329,320)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0.33 7.26 0.66 11 1 C11 7.6 11 14.2 11 21 C4.4 21 -2.2 21 -9 21 C-6.75 14.25 -6.75 14.25 -5.2734375 11.1328125 C-4.9640625 10.47539063 -4.6546875 9.81796875 -4.3359375 9.140625 C-3.86027344 8.14289063 -3.86027344 8.14289063 -3.375 7.125 C-2.88773437 6.09246094 -2.88773437 6.09246094 -2.390625 5.0390625 C-1.59676528 3.35794781 -0.79880442 1.67877079 0 0 Z ",
    fill: "#E7ECEE",
    transform: "translate(449,59)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.63 20 7.26 20 11 C22.31 11 24.62 11 27 11 C27 11.33 27 11.66 27 12 C23.43884042 12.67396301 19.87587859 13.33787818 16.3125 14 C15.30509766 14.19078125 14.29769531 14.3815625 13.25976562 14.578125 C12.28330078 14.75859375 11.30683594 14.9390625 10.30078125 15.125 C9.40528564 15.29257812 8.50979004 15.46015625 7.5871582 15.6328125 C5 16 5 16 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#E7ECEF",
    transform: "translate(460,560)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 4.62 20 9.24 20 14 C17.60468244 14.33745354 15.20885732 14.6700829 12.8125 15 C12.13896484 15.09539063 11.46542969 15.19078125 10.77148438 15.2890625 C7.1082905 15.78940118 3.71764056 16 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(340,580)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94 0 11.88 0 18 0 C15.69 6.93 13.38 13.86 11 21 C7.37 20.67 3.74 20.34 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E8ECEF",
    transform: "translate(400,260)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.24810335 3.78213135 1.03501717 7.46799294 0.87890625 11.390625 C0.85529526 12.09523865 0.83168427 12.79985229 0.80735779 13.52581787 C0.73103023 15.7674328 0.64687421 18.00867496 0.5625 20.25 C0.5092483 21.7734195 0.45650812 23.29685698 0.40429688 24.8203125 C0.27641421 28.54717869 0.1379422 32.27343831 0 36 C-4.95 36 -9.9 36 -15 36 C-14.16279243 30.97675455 -12.99344058 27.32401016 -10.83984375 22.8515625 C-10.53051407 22.19417084 -10.22118439 21.53677917 -9.90248108 20.85946655 C-8.92109627 18.77794394 -7.92950023 16.70148117 -6.9375 14.625 C-6.26689546 13.20735398 -5.59696649 11.78938817 -4.92773438 10.37109375 C-3.292948 6.9103143 -1.64899117 3.45403228 0 0 Z ",
    fill: "#F6FCFD",
    transform: "translate(400,164)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 10.89 1 21.78 1 33 C-3.95 33 -8.9 33 -14 33 C-13.1088532 28.544266 -11.96949608 25.44970526 -10.05859375 21.38671875 C-9.6278933 20.46509697 -9.6278933 20.46509697 -9.18849182 19.52485657 C-8.27660162 17.57662672 -7.35718807 15.632059 -6.4375 13.6875 C-5.81525374 12.36156334 -5.19350361 11.03539374 -4.57226562 9.70898438 C-3.05390965 6.4699404 -1.52878897 3.23413516 0 0 Z ",
    fill: "#F6FCFD",
    transform: "translate(259,467)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 6.6 20 13.2 20 20 C16.7 20 13.4 20 10 20 C10.65503282 15.94180817 11.94559121 12.46028718 13.5625 8.6875 C14.01753906 7.61886719 14.47257812 6.55023438 14.94140625 5.44921875 C15.29074219 4.64097656 15.64007813 3.83273438 16 3 C14.77023437 4.10021484 14.77023437 4.10021484 13.515625 5.22265625 C12.42766127 6.16993501 11.33908754 7.1165135 10.25 8.0625 C9.44175781 8.79049805 9.44175781 8.79049805 8.6171875 9.53320312 C7.015625 10.91015625 7.015625 10.91015625 4 13 C2.68 12.67 1.36 12.34 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#F3FBFD",
    transform: "translate(440,40)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C11.6016716 8.47033412 8.93481871 16.11976 5.875 24.125 C5.40163875 25.37994264 4.92897765 26.6351496 4.45703125 27.890625 C3.31151726 30.92974375 2.15905378 33.96602506 1 37 C0.67 37 0.34 37 0 37 C0 24.79 0 12.58 0 0 Z ",
    fill: "#F8FDFE",
    transform: "translate(440,160)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 2.97 20 5.94 20 9 C21.98 9 23.96 9 26 9 C26 9.33 26 9.66 26 10 C22.22988923 10.67079695 18.45880064 11.33592803 14.6875 12 C13.61564453 12.19078125 12.54378906 12.3815625 11.43945312 12.578125 C10.41142578 12.75859375 9.38339844 12.9390625 8.32421875 13.125 C7.37635498 13.29257812 6.42849121 13.46015625 5.4519043 13.6328125 C3 14 3 14 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#E6ECEF",
    transform: "translate(360,580)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C16 2 16 2 15.47094727 4.06298828 C15.17244873 4.89040527 14.8739502 5.71782227 14.56640625 6.5703125 C14.24736328 7.46621094 13.92832031 8.36210937 13.59960938 9.28515625 C13.25736328 10.22230469 12.91511719 11.15945313 12.5625 12.125 C12.05493164 13.54232422 12.05493164 13.54232422 11.53710938 14.98828125 C10.6981094 17.32802766 9.85215708 19.66502009 9 22 C8.67 21.34 8.34 20.68 8 20 C5.36 20 2.72 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E8EDEF",
    transform: "translate(380,320)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0 10.56 0 16 0 C12.0625 6.8125 12.0625 6.8125 10.82446289 8.94458008 C9.29413292 11.60783616 7.97382819 14.07851544 7 17 C11.29 17 15.58 17 20 17 C20 17.99 20 18.98 20 20 C13.4 20 6.8 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#E8ECEF",
    transform: "translate(40,540)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 3.63 20 7.26 20 11 C16.37 11 12.74 11 9 11 C9 11.66 9 12.32 9 13 C4.545 13.495 4.545 13.495 0 14 C0 9.38 0 4.76 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(240,600)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94 0 11.88 0 18 0 C18 6.6 18 13.2 18 20 C15.69 20 13.38 20 11 20 C11 18.02 11 16.04 11 14 C10.34 14 9.68 14 9 14 C9 13.34 9 12.68 9 12 C8.01 12 7.02 12 6 12 C4.02 8.04 2.04 4.08 0 0 Z ",
    fill: "#E8ECEE",
    transform: "translate(782,600)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.29 0 8.58 0 13 0 C11.58823529 14.82352941 11.58823529 14.82352941 9 20 C6.03 20 3.06 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#FBFDFE",
    transform: "translate(460,100)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 2.97 20 5.94 20 9 C13.38190423 11.46254726 6.99560484 11.18935472 0 11 C0 7.37 0 3.74 0 0 Z ",
    fill: "#F9FDFD",
    transform: "translate(480,560)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.99026656 3.88662327 7.6812995 7.96507123 11.3125 12.1875 C12.13717773 13.13012695 12.13717773 13.13012695 12.97851562 14.09179688 C17 18.76271351 17 18.76271351 17 21 C11.06 21 5.12 21 -1 21 C-1.02688864 17.87494304 -1.04678462 14.75011575 -1.0625 11.625 C-1.07087891 10.73554688 -1.07925781 9.84609375 -1.08789062 8.9296875 C-1.09111328 8.07890625 -1.09433594 7.228125 -1.09765625 6.3515625 C-1.10289307 5.56604004 -1.10812988 4.78051758 -1.11352539 3.97119141 C-1 2 -1 2 0 0 Z ",
    fill: "#E2EBF0",
    transform: "translate(521,499)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C10.49448731 7.4999701 8.0574467 13.99475202 5.4375 21 C5.01275391 22.15628906 4.58800781 23.31257813 4.15039062 24.50390625 C3.10779808 27.3388208 2.05751108 30.17062416 1 33 C0.67 33 0.34 33 0 33 C0 22.11 0 11.22 0 0 Z ",
    fill: "#F8FDFE",
    transform: "translate(420,220)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.93 0.495 6.93 0.495 14 1 C14.01417969 2.32773437 14.02835938 3.65546875 14.04296875 5.0234375 C14.29176615 18.74685277 14.29176615 18.74685277 20 31 C20.96443435 32.45430577 21.92304308 33.91249635 22.875 35.375 C23.30554688 35.98085938 23.73609375 36.58671875 24.1796875 37.2109375 C25.24038617 39.52427079 24.69573791 40.61698983 24 43 C23.44054687 41.9790625 22.88109375 40.958125 22.3046875 39.90625 C16.52474274 29.40940929 10.55938424 19.03280691 4.47216797 8.7109375 C3.60035889 7.22787109 3.60035889 7.22787109 2.7109375 5.71484375 C2.18806152 4.82917725 1.66518555 3.94351074 1.12646484 3.03100586 C0 1 0 1 0 0 Z ",
    fill: "#DDEBF2",
    transform: "translate(666,399)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.84791078 1.28263693 4.93204705 3.08966475 7.4375 6.25 C8.19933594 7.20390625 8.96117187 8.1578125 9.74609375 9.140625 C10.48988281 10.08421875 11.23367188 11.0278125 12 12 C12.75410156 12.88171875 13.50820313 13.7634375 14.28515625 14.671875 C16 17 16 17 16 20 C10.72 20 5.44 20 0 20 C0 13.4 0 6.8 0 0 Z ",
    fill: "#F4FBFD",
    transform: "translate(420,380)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C25.94 2.67 31.88 2.34 38 2 C38 2.33 38 2.66 38 3 C33.39288448 3.86018808 28.78473237 4.71450293 24.17553711 5.56347656 C22.60883464 5.85289324 21.04242344 6.14389141 19.47631836 6.43652344 C17.22064373 6.85771641 14.96397074 7.27314522 12.70703125 7.6875 C11.66298882 7.88436401 11.66298882 7.88436401 10.59785461 8.08520508 C7.01988602 8.73611689 3.63775572 9.14785121 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#E6ECEF",
    transform: "translate(500,560)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 2.31 20 4.62 20 7 C18.700625 7.103125 17.40125 7.20625 16.0625 7.3125 C11.73361797 7.77826579 7.92251563 8.87688577 3.84765625 10.37890625 C2 11 2 11 0 11 C0 7.37 0 3.74 0 0 Z ",
    fill: "#ECEDED",
    transform: "translate(260,600)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 2.31 20 4.62 20 7 C13.1834265 8.7879537 7.03482474 9.23668569 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#F7FDFE",
    transform: "translate(380,580)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.3 0 6.6 0 10 0 C8.49163573 8.0359407 5.7718177 15.43096765 2.875 23.0625 C2.40179368 24.32205911 1.92913331 25.58182346 1.45703125 26.84179688 C0.31002222 29.89658624 -0.84243637 32.949198 -2 36 C-2.33 36 -2.66 36 -3 36 C-3.15943997 33.2098006 -3.12935229 31.30163976 -2.01806641 28.71020508 C-0.85619886 25.61718549 -0.68340315 23.12180654 -0.5859375 19.82421875 C-0.54726563 18.66728516 -0.50859375 17.51035156 -0.46875 16.31835938 C-0.4378125 15.12017578 -0.406875 13.92199219 -0.375 12.6875 C-0.33632813 11.46998047 -0.29765625 10.25246094 -0.2578125 8.99804688 C-0.16371998 5.99884772 -0.07807791 2.99965177 0 0 Z ",
    fill: "#EFFAFD",
    transform: "translate(400,280)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.27 0 12.54 0 19 0 C15.17218298 3.82781702 11.3723984 7.34320067 7.25 10.8125 C6.66089844 11.31458984 6.07179688 11.81667969 5.46484375 12.33398438 C1.12547832 16 1.12547832 16 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#E3ECF0",
    transform: "translate(320,140)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-6.51407459 2.14168097 -13.02860263 3.28074613 -19.54345703 4.41796875 C-21.76101108 4.80538256 -23.9784595 5.19340152 -26.19580078 5.58203125 C-29.37765558 6.13960259 -32.55988034 6.69501706 -35.7421875 7.25 C-37.23599442 7.51248535 -37.23599442 7.51248535 -38.75997925 7.78027344 C-39.68078278 7.94043945 -40.6015863 8.10060547 -41.55029297 8.265625 C-42.3630368 8.40774414 -43.17578064 8.54986328 -44.01315308 8.69628906 C-46 9 -46 9 -48 9 C-48 6.69 -48 4.38 -48 2 C-47.01193359 1.97494385 -46.02386719 1.9498877 -45.00585938 1.92407227 C-41.30815676 1.82925282 -37.61060975 1.72922025 -33.91308594 1.62768555 C-32.31872216 1.58461643 -30.72432053 1.54292424 -29.12988281 1.50268555 C-26.82605625 1.44429695 -24.52241541 1.38080789 -22.21875 1.31640625 C-21.16512268 1.29133751 -21.16512268 1.29133751 -20.09020996 1.26576233 C-13.35346072 1.06819478 -6.74034949 -0.16850874 0 0 Z ",
    fill: "#E0EFF3",
    transform: "translate(448,578)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.33242119 3.33242119 6.58056626 6.64713143 9.75 10.125 C10.52859375 10.97320313 11.3071875 11.82140625 12.109375 12.6953125 C14 15 14 15 15 18 C10.05 18 5.1 18 0 18 C0 12.06 0 6.12 0 0 Z ",
    fill: "#E1EBF0",
    transform: "translate(540,522)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C6.64034 6.84013569 4.63746418 13.165329 2.1875 19.6875 C1.4723385 21.62097625 0.75749501 23.55457015 0.04296875 25.48828125 C-0.30459473 26.42365723 -0.6521582 27.3590332 -1.01025391 28.32275391 C-2.36852392 31.99685084 -3.68927617 35.68372358 -5 39.375 C-5.5878125 41.02628906 -5.5878125 41.02628906 -6.1875 42.7109375 C-6.455625 43.46632812 -6.72375 44.22171875 -7 45 C-8.12461538 41.68317925 -7.89008593 39.94538892 -6.6015625 36.71875 C-6.28711182 35.88561279 -5.97266113 35.05247559 -5.64868164 34.1940918 C-5.3108667 33.3050415 -4.97305176 32.41599121 -4.625 31.5 C-0.81419618 20.93650751 0.08392733 11.1623353 0 0 Z ",
    fill: "#ECEDEE",
    transform: "translate(460,120)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.86630462 1.62210154 7.29109751 5.77996167 10 10 C10.9375 13.5625 10.9375 13.5625 11 16 C7.37 16 3.74 16 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#F4FBFD",
    transform: "translate(440,404)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 6.6 2 13.2 2 20 C-0.97 20 -3.94 20 -7 20 C-6.47493172 14.78254934 -5.2201441 10.77348889 -2.9375 6.0625 C-2.38964844 4.91910156 -1.84179688 3.77570313 -1.27734375 2.59765625 C-0.85582031 1.74042969 -0.43429687 0.88320313 0 0 Z ",
    fill: "#F6FCFE",
    transform: "translate(318,340)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C7.36433437 6.68412752 3.70775764 13.35556707 0 20 C-1.19799449 15.85340627 -0.8896192 12.00630953 -0.5625 7.75 C-0.51029297 7.00492187 -0.45808594 6.25984375 -0.40429688 5.4921875 C-0.2751783 3.66105139 -0.13834886 1.83046187 0 0 Z ",
    fill: "#E0ECF2",
    transform: "translate(160,340)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 5.28 9 10.56 9 16 C8.34 16 7.68 16 7 16 C7 15.34 7 14.68 7 14 C6.01 13.67 5.02 13.34 4 13 C0.88411004 8.4597032 -0.54998918 5.63738908 0 0 Z ",
    fill: "#F6FCFE",
    transform: "translate(531,160)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 5.94 11 11.88 11 18 C7.88948463 14.88948463 5.93180571 11.66905543 3.8125 7.875 C3.44447266 7.22917969 3.07644531 6.58335937 2.69726562 5.91796875 C0 1.14395872 0 1.14395872 0 0 Z ",
    fill: "#E0EBF1",
    transform: "translate(609,300)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0 9.9 0 15 0 C11.78986213 3.21013787 8.62909341 6.30193188 5.25 9.3125 C4.47140625 10.00988281 3.6928125 10.70726562 2.890625 11.42578125 C1 13 1 13 0 13 C0 8.71 0 4.42 0 0 Z ",
    fill: "#E1EBF1",
    transform: "translate(300,160)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.6 1 13.2 1 20 C-1.97 20 -4.94 20 -8 20 C-5.83836487 13.06001352 -3.1063786 6.56882431 0 0 Z ",
    fill: "#E4ECEF",
    transform: "translate(439,80)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.27 1 12.54 1 19 C-1.97 19 -4.94 19 -8 19 C-6.60121198 14.53202662 -4.86369228 10.36177921 -2.875 6.125 C-2.33617187 4.97257812 -1.79734375 3.82015625 -1.2421875 2.6328125 C-0.62730469 1.32957031 -0.62730469 1.32957031 0 0 Z ",
    fill: "#E4ECF0",
    transform: "translate(299,381)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C8.41748651 3.99848769 7.16686722 6.81303838 5.0625 10.25 C4.53785156 11.12140625 4.01320313 11.9928125 3.47265625 12.890625 C2 15 2 15 0 16 C0 10.72 0 5.44 0 0 Z ",
    fill: "#F2FCFE",
    transform: "translate(80,480)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.62 0 9.24 0 14 0 C8.80412371 6.49484536 8.80412371 6.49484536 5 9 C2.1875 9.25 2.1875 9.25 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#F3FCFE",
    transform: "translate(420,60)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9.33 5.94 9.66 11.88 10 18 C7.5122759 14.68303453 5.40272468 11.44196622 3.3125 7.875 C2.68988281 6.82054687 2.06726563 5.76609375 1.42578125 4.6796875 C0 2 0 2 0 0 Z ",
    fill: "#DEECF2",
    transform: "translate(771,580)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 4.29 9 8.58 9 13 C8.34 13 7.68 13 7 13 C7 12.34 7 11.68 7 11 C6.01 10.67 5.02 10.34 4 10 C2.83203125 8.4765625 2.83203125 8.4765625 1.8125 6.625 C1.46832031 6.01914062 1.12414062 5.41328125 0.76953125 4.7890625 C0 3 0 3 0 0 Z ",
    fill: "#F5FDFE",
    transform: "translate(691,440)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.50812438 1.75406219 4.84380893 2.61204837 7.25 5.4375 C7.77078125 6.03433594 8.2915625 6.63117188 8.828125 7.24609375 C10 9 10 9 10 12 C6.7 12 3.4 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#ECF9FD",
    transform: "translate(460,428)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C6.42986223 5.96652354 3.24970218 10.82909025 0 16 C-1.16306443 12.45049966 -0.92365049 9.44176052 -0.5625 5.75 C-0.46066406 4.67234375 -0.35882813 3.5946875 -0.25390625 2.484375 C-0.17011719 1.66453125 -0.08632812 0.8446875 0 0 Z ",
    fill: "#DCEBF3",
    transform: "translate(220,240)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 4.95 9 9.9 9 15 C6.57722907 11.76963876 4.70562325 8.78383006 2.8125 5.25 C2.28269531 4.26515625 1.75289062 3.2803125 1.20703125 2.265625 C0.80871094 1.51796875 0.41039062 0.7703125 0 0 Z ",
    fill: "#DAEAF2",
    transform: "translate(551,200)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.36948916 3.95630201 0.77791742 5.33249547 0 10 C-6.6 10 -13.2 10 -20 10 C-20 9.01 -20 8.02 -20 7 C-13.73 7 -7.46 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#E8EDEF",
    transform: "translate(220,550)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.09940103 3.29820308 0.97345651 3.7926273 -0.15234375 6.89453125 C-0.56987915 8.06580566 -0.56987915 8.06580566 -0.99584961 9.26074219 C-1.30659424 10.10282227 -1.61733887 10.94490234 -1.9375 11.8125 C-2.25017822 12.68165039 -2.56285645 13.55080078 -2.88500977 14.44628906 C-3.91446083 17.30082613 -4.95709107 20.1503549 -6 23 C-6.75072238 25.07135291 -7.5007161 27.14297005 -8.25 29.21484375 C-10.15668643 34.48022841 -12.0744437 39.74148903 -14 45 C-15.16516019 41.59478519 -14.82953411 39.63555399 -13.671875 36.26171875 C-13.36636719 35.35873047 -13.06085938 34.45574219 -12.74609375 33.52539062 C-12.41738281 32.58888672 -12.08867187 31.65238281 -11.75 30.6875 C-11.43675781 29.76259766 -11.12351562 28.83769531 -10.80078125 27.88476562 C-9.42548281 23.87014965 -8.00590306 19.9062073 -6.30859375 16.015625 C-5.12946281 13.29834416 -4.44188507 10.91644146 -4 8 C-3.34 8 -2.68 8 -2 8 C-1.7834375 6.576875 -1.7834375 6.576875 -1.5625 5.125 C-1 2 -1 2 0 0 Z ",
    fill: "#C5EAFB",
    transform: "translate(467,120)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.66666667 1.66666667 3.33333333 3.33333333 5 5 C5.763125 5.721875 6.52625 6.44375 7.3125 7.1875 C9 9 9 9 9 11 C4.545 11.495 4.545 11.495 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#E5EDF1",
    transform: "translate(560,546)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C5.02 5.61 3.04 11.22 1 17 C0.67 17 0.34 17 0 17 C0 11.39 0 5.78 0 0 Z ",
    fill: "#DEECF3",
    transform: "translate(440,180)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C13.4 3 6.8 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(180,557)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C13.4 3 6.8 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#EDEDEE",
    transform: "translate(160,557)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C13.4 3 6.8 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(140,557)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C13.4 3 6.8 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#EDEDEE",
    transform: "translate(120,557)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C13.4 3 6.8 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#FDFDFE",
    transform: "translate(100,557)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C13.4 3 6.8 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#EDEDEE",
    transform: "translate(80,557)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.6 0 13.2 0 20 0 C20 0.99 20 1.98 20 3 C13.4 3 6.8 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#FDFEFE",
    transform: "translate(60,557)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C7.84778899 4.41309542 4.44536093 7.00793014 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#DDEBF2",
    transform: "translate(280,180)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.64 0.66 -5.28 1.32 -8 2 C-3.71 2.33 0.58 2.66 5 3 C5 3.33 5 3.66 5 4 C-3.58 4 -12.16 4 -21 4 C-21 3.34 -21 2.68 -21 2 C-18.25162151 1.46892686 -15.50187625 0.94984119 -12.75 0.4375 C-11.97269531 0.28603516 -11.19539062 0.13457031 -10.39453125 -0.02148438 C-9.64042969 -0.16005859 -8.88632813 -0.29863281 -8.109375 -0.44140625 C-7.07248535 -0.63778687 -7.07248535 -0.63778687 -6.01464844 -0.83813477 C-4 -1 -4 -1 0 0 Z ",
    fill: "#1F8AC6",
    transform: "translate(254,614)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C5.51481201 4.04301175 3.57122002 7.61146256 1.375 11.3125 C0.74335937 12.38113281 0.11171875 13.44976563 -0.5390625 14.55078125 C-1.26222656 15.76314453 -1.26222656 15.76314453 -2 17 C-2.33 15.68 -2.66 14.36 -3 13 C-2.34 13 -1.68 13 -1 13 C-0.67 8.71 -0.34 4.42 0 0 Z ",
    fill: "#D9ECF5",
    transform: "translate(60,520)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 3.96 7 7.92 7 12 C3.87855452 8.87855452 1.95105386 6.80455503 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#ECFAFD",
    transform: "translate(633,340)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7.33 4.62 7.66 9.24 8 14 C5.64662777 10.86217036 4.00315795 8.22270281 2.3125 4.75 C1.65701172 3.41195313 1.65701172 3.41195313 0.98828125 2.046875 C0.66214844 1.37140625 0.33601562 0.6959375 0 0 Z ",
    fill: "#DBECF4",
    transform: "translate(713,480)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C-1.31 10 -3.62 10 -6 10 C-5.67 8.02 -5.34 6.04 -5 4 C-4.01 4 -3.02 4 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#F4FCFD",
    transform: "translate(419,130)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C6.98888806 4.02222388 5.59551067 5.48314253 2 8 C1.34 8 0.68 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#EFFBFE",
    transform: "translate(400,80)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.25083612 4.51505017 1.25083612 4.51505017 0.0625 6.8125 C-1.54028556 10.11235262 -1.63600233 13.36002331 -2 17 C-3.65 17 -5.3 17 -7 17 C-5.1668733 11.00067626 -2.92678249 5.55079437 0 0 Z ",
    fill: "#D9F2FB",
    transform: "translate(382,203)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.36757331 4.72502701 0.08186437 8.90570197 -1.5625 13.375 C-1.79646484 14.01566406 -2.03042969 14.65632812 -2.27148438 15.31640625 C-2.84299619 16.8793161 -3.42084229 18.43990727 -4 20 C-4.33 20 -4.66 20 -5 20 C-5 15.71 -5 11.42 -5 7 C-3.68 7 -2.36 7 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#D9EFF7",
    transform: "translate(425,233)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5.3227506 4.62609198 4.84450614 7.28026121 2 11 C1.34 11 0.68 11 0 11 C0 7.37 0 3.74 0 0 Z ",
    fill: "#F3FCFE",
    transform: "translate(140,380)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C0.01 5.485 0.01 5.485 -1 7 C-1.66 7 -2.32 7 -3 7 C-3.144375 7.78375 -3.28875 8.5675 -3.4375 9.375 C-4 12 -4 12 -5 14 C-5.66 14 -6.32 14 -7 14 C-7.144375 14.78375 -7.28875 15.5675 -7.4375 16.375 C-8 19 -8 19 -9 21 C-9.99 20.67 -10.98 20.34 -12 20 C-8.04 13.4 -4.08 6.8 0 0 Z ",
    fill: "#248DC8",
    transform: "translate(172,338)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.5625 1.9375 2.5625 1.9375 3 4 C0.66199808 6.33800192 -4.40449274 6.09472997 -7.5625 6.5625 C-8.88604492 6.77036133 -8.88604492 6.77036133 -10.23632812 6.98242188 C-15.55627077 7.78060987 -20.62161091 8.14434416 -26 8 C-26 7.67 -26 7.34 -26 7 C-22.06316446 6.32936905 -18.12542943 5.66417499 -14.1875 5 C-13.06794922 4.80921875 -11.94839844 4.6184375 -10.79492188 4.421875 C-9.72177734 4.24140625 -8.64863281 4.0609375 -7.54296875 3.875 C-6.55321045 3.70742188 -5.56345215 3.53984375 -4.54370117 3.3671875 C-2 3 -2 3 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#2E91C9",
    transform: "translate(568,554)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 2.97 0 5.94 0 9 C-2.31 9 -4.62 9 -7 9 C-6.69740962 5.36891547 -6.2363202 4.21859619 -3.5 1.6875 C-1 0 -1 0 0 0 Z ",
    fill: "#F6FDFE",
    transform: "translate(280,431)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-3.54004203 1.6754914 -7.08226169 2.33880798 -10.625 3 C-11.62402344 3.19078125 -12.62304688 3.3815625 -13.65234375 3.578125 C-18.49052593 4.47527136 -23.05392418 5.27009288 -28 5 C-28 4.67 -28 4.34 -28 4 C-24.7 3.67 -21.4 3.34 -18 3 C-18 2.34 -18 1.68 -18 1 C-16.12528812 0.83012319 -14.25021305 0.66425224 -12.375 0.5 C-11.33085938 0.4071875 -10.28671875 0.314375 -9.2109375 0.21875 C-6.12853212 0.00875645 -3.08834771 -0.03709727 0 0 Z ",
    fill: "#C2ECFA",
    transform: "translate(538,562)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.35620271 1.38877354 5.07298728 2.91677965 7 6 C7 6.66 7 7.32 7 8 C4.69 8 2.38 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#EBFAFD",
    transform: "translate(480,452)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.2864838 4.23891786 0.51446203 6.8172001 -1 11 C-3 14.4375 -3 14.4375 -5 17 C-5.66 17 -6.32 17 -7 17 C-5.24009216 11.08030998 -2.60305395 5.58365008 0 0 Z ",
    fill: "#CCE9F7",
    transform: "translate(400,164)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 3.63 6 7.26 6 11 C2.90407165 7.4912812 1.25805377 4.50802601 0 0 Z ",
    fill: "#D9EBF4",
    transform: "translate(494,100)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-3.56115958 1.67396301 -7.12412141 2.33787818 -10.6875 3 C-11.69490234 3.19078125 -12.70230469 3.3815625 -13.74023438 3.578125 C-14.71669922 3.75859375 -15.69316406 3.9390625 -16.69921875 4.125 C-17.59471436 4.29257812 -18.49020996 4.46015625 -19.4128418 4.6328125 C-21.98012932 4.99717982 -24.41092013 5.06528807 -27 5 C-22.00261034 2.40876092 -17.725229 0.76854873 -12.0625 0.375 C-10.56396484 0.26285156 -10.56396484 0.26285156 -9.03515625 0.1484375 C-6.01790877 0.00087585 -3.02032183 -0.02700735 0 0 Z ",
    fill: "#C3EAFA",
    transform: "translate(289,606)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.625 1.8125 0.625 1.8125 1 4 C0.01 5.485 0.01 5.485 -1 7 C-1.66 7 -2.32 7 -3 7 C-3.103125 7.721875 -3.20625 8.44375 -3.3125 9.1875 C-4.06793947 12.27793421 -5.15531315 14.41743841 -7 17 C-7.66 17 -8.32 17 -9 17 C-7.51481201 12.95698825 -5.57122002 9.38853744 -3.375 5.6875 C-2.74335937 4.61886719 -2.11171875 3.55023437 -1.4609375 2.44921875 C-0.97882812 1.64097656 -0.49671875 0.83273437 0 0 Z ",
    fill: "#268EC9",
    transform: "translate(62,529)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.57316761 2.58624235 1.13303842 4.1689098 0.6875 5.75 C0.44386719 6.63171875 0.20023437 7.5134375 -0.05078125 8.421875 C-1.03192105 11.08669915 -2.093824 12.90271638 -4 15 C-4.66 15 -5.32 15 -6 15 C-4.36041242 9.76727367 -2.61047965 4.84803364 0 0 Z ",
    fill: "#D2F0FB",
    transform: "translate(421,119)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.06553465 4.03144641 -0.93224776 6.03533587 -2 8 C-2.66 7.34 -3.32 6.68 -4 6 C-6.31 7.98 -8.62 9.96 -11 12 C-11.66 11.67 -12.32 11.34 -13 11 C-11.39801112 9.53927468 -9.79332884 8.08150284 -8.1875 6.625 C-7.29417969 5.81289063 -6.40085937 5.00078125 -5.48046875 4.1640625 C-3 2 -3 2 0 0 Z ",
    fill: "#328FC5",
    transform: "translate(456,42)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-6.27 1.99 -12.54 2.98 -19 4 C-19 3.34 -19 2.68 -19 2 C-12.65176798 -0.30844801 -6.70518586 -0.19818283 0 0 Z ",
    fill: "#C4E7F9",
    transform: "translate(419,583)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.99 1.32 1.98 2 3 C0.02 6.96 -1.96 10.92 -4 15 C-4.66 15 -5.32 15 -6 15 C-4.40109514 9.80355921 -2.25861997 4.93387858 0 0 Z ",
    fill: "#C3E6F7",
    transform: "translate(371,226)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.602537 6.02536998 1.602537 6.02536998 -0.11328125 8.80078125 C-1.34621853 10.25599455 -2.66808933 11.63479157 -4 13 C-4.33 12.34 -4.66 11.68 -5 11 C-4.00390625 8.3984375 -4.00390625 8.3984375 -2.5625 5.375 C-2.08941406 4.37210937 -1.61632812 3.36921875 -1.12890625 2.3359375 C-0.75636719 1.56507813 -0.38382812 0.79421875 0 0 Z ",
    fill: "#C9E7F6",
    transform: "translate(259,467)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0680182 2.77684731 0.96475091 4.16022313 0.3125 7.125 C-1 10 -1 10 -3.125 11.375 C-3.74375 11.58125 -4.3625 11.7875 -5 12 C-3.68938409 7.76570244 -2.05643741 3.92592596 0 0 Z ",
    fill: "#D4F2FB",
    transform: "translate(280,422)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 1.32 0.66 2.64 1 4 C0.34 4 -0.32 4 -1 4 C-1.103125 4.721875 -1.20625 5.44375 -1.3125 6.1875 C-2.06793947 9.27793421 -3.15531315 11.41743841 -5 14 C-5.66 14 -6.32 14 -7 14 C-5.23570801 9.02790438 -2.6060834 4.56561939 0 0 Z ",
    fill: "#228CC8",
    transform: "translate(226,244)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C3.375 4.875 3.375 4.875 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#D5E9F3",
    transform: "translate(260,200)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.94 0 11.88 0 18 0 C18 0.33 18 0.66 18 1 C16.67935547 1.09087891 16.67935547 1.09087891 15.33203125 1.18359375 C13.58986328 1.30927734 13.58986328 1.30927734 11.8125 1.4375 C10.66394531 1.51871094 9.51539063 1.59992187 8.33203125 1.68359375 C5.48401829 1.95403812 2.78789518 2.37521747 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#EBEEF0",
    transform: "translate(300,600)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 2.64 5 5.28 5 8 C2.20127563 5.47211993 0.54226981 3.79588866 0 0 Z ",
    fill: "#EAFAFE",
    transform: "translate(575,240)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.12613393 2.96160056 5.04783565 5.09567131 7 9 C2.545 9.495 2.545 9.495 -2 10 C-2 9.67 -2 9.34 -2 9 C-0.35 8.67 1.3 8.34 3 8 C2.690625 7.4225 2.38125 6.845 2.0625 6.25 C1.07416636 4.15705816 0.4831387 2.25464725 0 0 Z ",
    fill: "#B8E4F9",
    transform: "translate(562,548)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.61528766 5.07612318 -0.38341651 7.82982006 -3 12 C-3.66 12 -4.32 12 -5 12 C-3.68938409 7.76570244 -2.05643741 3.92592596 0 0 Z ",
    fill: "#BFE4F7",
    transform: "translate(232,525)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.3125 3.25 1.3125 3.25 1 7 C-1.5 9.4375 -1.5 9.4375 -4 11 C-3.52269162 9.5410574 -3.04308958 8.08286504 -2.5625 6.625 C-2.29566406 5.81289063 -2.02882813 5.00078125 -1.75390625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#C8E7F6",
    transform: "translate(299,381)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.00000429 4.00001715 0.80688405 6.05523353 0 10 C-1.32 9.67 -2.64 9.34 -4 9 C-2.68 6.03 -1.36 3.06 0 0 Z ",
    fill: "#CAE8F6",
    transform: "translate(360,250)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93045933 2.55144824 1.08564091 3.74006478 0.22265625 6.359375 C-0.16019531 7.14828125 -0.54304688 7.9371875 -0.9375 8.75 C-1.50791016 9.94882813 -1.50791016 9.94882813 -2.08984375 11.171875 C-2.39019531 11.77515625 -2.69054687 12.3784375 -3 13 C-3.66 13 -4.32 13 -5 13 C-3.58192622 8.52761347 -1.88695626 4.28853694 0 0 Z ",
    fill: "#C3E6F8",
    transform: "translate(439,80)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C3.68 2.64 2.36 5.28 1 8 C0.67 8 0.34 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#CFE8F5",
    transform: "translate(120,420)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C5 2.64 5 5.28 5 8 C2.74754119 5.31158141 1.11786042 3.35358125 0 0 Z ",
    fill: "#D0E8F5",
    transform: "translate(655,380)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.3125 2.25 2.3125 2.25 2 5 C-0.5 7.3125 -0.5 7.3125 -3 9 C-2.01 6.03 -1.02 3.06 0 0 Z ",
    fill: "#D9F4FC",
    transform: "translate(318,340)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 1.32 2.64 2.64 4 4 C3.67 4.66 3.34 5.32 3 6 C0.4375 6.625 0.4375 6.625 -2 7 C-1.34 4.69 -0.68 2.38 0 0 Z ",
    fill: "#268DC6",
    transform: "translate(482,83)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.625 1.8125 0.625 1.8125 1 4 C0.01 5.485 0.01 5.485 -1 7 C-1.66 7 -2.32 7 -3 7 C-3 7.99 -3 8.98 -3 10 C-3.66 10 -4.32 10 -5 10 C-3.66511872 6.40608886 -2.03977277 3.24509304 0 0 Z ",
    fill: "#2C92CA",
    transform: "translate(146,383)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.625 1.8125 0.625 1.8125 1 4 C0.01 5.485 0.01 5.485 -1 7 C-1.66 7 -2.32 7 -3 7 C-3 7.99 -3 8.98 -3 10 C-3.66 10 -4.32 10 -5 10 C-3.66511872 6.40608886 -2.03977277 3.24509304 0 0 Z ",
    fill: "#288FCA",
    transform: "translate(236,227)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C4.71937515 1.7074998 3.38232443 3.37373596 2 5 C1.34 5 0.68 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#EBFCFE",
    transform: "translate(380,100)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C-0.65 6 -2.3 6 -4 6 C-1.125 1.125 -1.125 1.125 0 0 Z ",
    fill: "#ECEDEE",
    transform: "translate(259,474)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.95465783 2.16967689 1.14401212 3.56328793 0.3984375 5.82421875 C-0.35870385 7.5684743 -1.17609198 9.28627131 -2 11 C-2.66 11 -3.32 11 -4 11 C-2.7874262 7.27566618 -1.49140021 3.62197194 0 0 Z ",
    fill: "#CBEFFB",
    transform: "translate(329,316)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.3636198 4.24223102 0.5393228 6.58168085 -2 10 C-2.66 10 -3.32 10 -4 10 C-2.8905928 6.51329166 -1.73662334 3.22515763 0 0 Z ",
    fill: "#BFE3F6",
    transform: "translate(334,306)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C0.75 6.75 0.75 6.75 -1 9 C-1.66 9 -2.32 9 -3 9 C-2.01 6.03 -1.02 3.06 0 0 Z ",
    fill: "#CEECF9",
    transform: "translate(236,516)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.22265625 3.9453125 0.22265625 3.9453125 -0.9375 6.125 C-1.31777344 6.84945313 -1.69804687 7.57390625 -2.08984375 8.3203125 C-2.39019531 8.87460937 -2.69054687 9.42890625 -3 10 C-3.66 10 -4.32 10 -5 10 C-3.66511872 6.40608886 -2.03977277 3.24509304 0 0 Z ",
    fill: "#268EC7",
    transform: "translate(194,300)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C0.625 6 0.625 6 -1 8 C-1.66 8 -2.32 8 -3 8 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#CEECF8",
    transform: "translate(348,276)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C-0.65 6 -2.3 6 -4 6 C-2.69593116 3.98079663 -1.36176581 1.98075027 0 0 Z ",
    fill: "#EDEDEE",
    transform: "translate(399,174)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureIcon);
export default __webpack_public_path__ + "static/media/azure-icon.d6772f0a4b4ecfa798241c9e8058d14b.svg";
export { ForwardRef as ReactComponent };